import FuseUtils from '@fuse/utils';
import FuseLoading from '@fuse/core/FuseLoading';
import { Navigate } from 'react-router-dom';
import settingsConfig from 'app/configs/settingsConfig';
import OrdersConfig from '../main/orders/OrdersConfig';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignUpConfig from '../main/sign-up/SignUpConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import UnsubscribeConfig from '../main/email-unsubscribe/UnsubscribeConfig';
import Error404Page from '../main/404/Error404Page';
import SignUpConfirmationConfig from '../main/sign-up-confirmation/SignUpConfirmationConfig';
import AccountConfirmationConfig from '../main/account-confirmation/AccountConfirmationConfig';
import Error500Page from '../main/500/Error500Page';
import ClientsConfig from '../main/clients/ClientsConfig';
import ClientDetailsConfig from '../main/client-details/ClientDetailsConfig';
import AddClientConfig from '../main/add-client/AddClientConfig';
import EditClientOrderConfig from '../main/edit-client-order/EditClientOrderConfig';
import AddOrderConfig from '../main/order/AddOrderConfig';
import OrderDetailsConfig from '../main/order-details/OrderDetailsConfig';
import LeadsConfig from '../main/leads/LeadsConfig';
import TicketsConfig from '../main/tickets/TicketsConfig';
import UsersConfig from '../main/users/UsersConfig';
import AddUserConfig from '../main/add-users/AddUserConfig';
import UserDetailsConfig from '../main/user-details/UserDetailsConfig';
import CompaniesConfig from '../main/companies/CompaniesConfig';
import CompanyDetailsConfig from '../main/company-details/CompanyDetailsConfig';
import AddCompanyConfig from '../main/add-company/AddCompanyConfig';
import ProcessingConfig from '../main/processing/ProcessingConfig';
import SalesConfig from '../main/sales/SalesConfig';
import ProvidersConfig from '../main/providers/ProvidersConfig';
import ProviderDetailsConfig from '../main/provider-details/ProviderDetailsConfig';
import AddProviderConfig from '../main/add-provider/AddProviderConfig';
import AddServiceConfig from '../main/add-service/AddServiceConfig';
import SendInviteConfig from '../main/send-invite/SendInviteConfig';
import InvitesConfig from '../main/invites/InvitesConfig';
import PayorsConfig from '../main/payors/PayorsConfig';
import AddPayorConfig from '../main/add-payor/AddPayorConfig';
import ReferralInviteConfig from '@/app/main/referral-sign-in/ReferralInviteConfig';
import DepositsConfig from '../main/deposits/DepositsConfig';
import DepositDetailsConfig from '../main/deposit-details/DepositDetailsConfig';
import SubscriptionsConfig from '../main/subscriptions/SubscriptionsConfig';
import GoalsConfig from '../main/goals/GoalsConfig';
import AddGoalConfig from '../main/add-goal/AddGoalConfig';
import ForgotPasswordConfig from '../main/forgot-password/ForgotPasswordConfig';
import ResetPasswordPage from '../main/reset-password/ResetPasswordConfig';
import AddVaultConfig from '../main/add-vault/AddVaultConfig';
import VaultCreatedConfirmationConfig from '@/app/main/vault-created-confirmation/VaultCreatedConfirmationConfig';
import SalesReportsPageConfig from '../main/reports/ReportsPageConfig';
import SalesAttritionReportConfig from '../main/sales-attrition-report/SalesAttritionReportConfig';
import NextHomeSignInConfig from '../main/nexthome-sign-in/NextHomeSignInConfig';
import CompanySummaryConfig from '../main/company-summary/CompanySummaryConfig';
import CompanyServicesSummaryConfig from '../main/services/CompanyServicesSummaryConfig';
import TestimonialsConfig from '../main/testimonials/TestimonialsConfig';
import RoleBasedRedirect from './RolesBasedRedirection';
import CancellationReasonsConfig from '../main/cancellation-reasons/CancellationReasonsConfig';
import MessagingRulesConfig from '../main/messaging-rules/MessagingRulesConfig';
import MessageTemplatesConfig from '../main/message-templates/MessageTemplatesConfig';
import DsiInformationConfig from '../main/dsi-information/DsiInformationConfig';
import PaymentsConfig from '../main/payments/PaymentsConfig';
import PaymentDetailsConfig from '../main/payment-details/PaymentDetailsConfig';
import PayItemDetailsConfig from '../main/pay-item-details/PayItemDetailsConfig';

const routeConfigs = [
  SignOutConfig,
  SignInConfig,
  SignUpConfig,
  UnsubscribeConfig,
  SignUpConfirmationConfig,
  AccountConfirmationConfig,
  ClientsConfig,
  ClientDetailsConfig,
  AddClientConfig,
  EditClientOrderConfig,
  OrdersConfig,
  AddOrderConfig,
  OrderDetailsConfig,
  LeadsConfig,
  TicketsConfig,
  UsersConfig,
  AddUserConfig,
  CompaniesConfig,
  AddCompanyConfig,
  UserDetailsConfig,
  CompanyDetailsConfig,
  ProcessingConfig,
  SalesConfig,
  ProvidersConfig,
  ProviderDetailsConfig,
  AddProviderConfig,
  AddServiceConfig,
  SendInviteConfig,
  InvitesConfig,
  PayorsConfig,
  AddPayorConfig,
  ReferralInviteConfig,
  DepositsConfig,
  DepositDetailsConfig,
  PaymentsConfig,
  PaymentDetailsConfig,
  PayItemDetailsConfig,
  SubscriptionsConfig,
  GoalsConfig,
  AddGoalConfig,
  ForgotPasswordConfig,
  ResetPasswordPage,
  AddVaultConfig,
  VaultCreatedConfirmationConfig,
  SalesReportsPageConfig,
  SalesAttritionReportConfig,
  NextHomeSignInConfig,
  DsiInformationConfig,
  CompanySummaryConfig,
  CompanyServicesSummaryConfig,
  TestimonialsConfig,
  CancellationReasonsConfig,
  MessagingRulesConfig,
  MessageTemplatesConfig,
];

const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs, settingsConfig.defaultAuth),
  {
    path: '/',
    element: <RoleBasedRedirect />,
    auth: settingsConfig.defaultAuth,
  },
  {
    path: 'loading',
    element: <FuseLoading />,
  },
  {
    path: '404',
    element: <Error404Page />,
  },
  {
    path: '500',
    element: <Error500Page />,
  },
  {
    path: '*',
    element: <Navigate to='404' />,
  },
];

export default routes;
